import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "action-bar-m" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (this.store.state.map_shown)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {this.store.state.map_shown = false;}, ["prevent"]))
        }, " Masquer la carte "))
      : _createCommentVNode("", true)
  ]))
}